import Vue from 'vue'
import Router from 'vue-router'
import about from 'components/about/about'
import solution from 'components/solution/solution'
import index from 'components/index/index'
import product from 'components/product/product'
import energy from 'components/energy/energy'
import battery from 'components/battery/battery'
import platform from 'components/platform/platform'
import virtualPower from 'components/virtualPower/virtualPower'
import bigData from 'components/bigData/bigData'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/solution',
      name: 'solution',
      component: solution
    },
    {
      path: '/energy',
      name: 'energy',
      component: energy
    },
    {
      path: '/battery',
      name: 'battery',
      component: battery
    },
    {
      path: '/virtualPower',
      name: 'virtualPower',
      component: virtualPower
    },
    {
      path: '/platform',
      name: 'platform',
      component: platform
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/bigData',
      name: 'bigData',
      component: bigData
    },
    {
      path: '/index',
      name: 'index',
      component: index,
    }
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js